import useUiNotification from '~/composables/useUiNotification';

export default defineNuxtPlugin((nuxtApp) => {
  const log = useCustomLogger();
  const router = useRouter();
  const { send } = useUiNotification();

  const errorCode = router.currentRoute.value?.query?.error;
  if (errorCode) {
    switch (errorCode) {
      case 'IMSIF_01':
        send({
          icon: 'profile_filled',
          message: 'somethingWentWrong',
          type: 'danger',
        });
        break;
      case 'IMLF_01':
        send({
          icon: 'profile_filled',
          message: 'somethingWentWrong',
          type: 'danger',
        });
        break;
      case 'IMDT_01':
        send({
          icon: 'profile_filled',
          message: 'delete account error',
          type: 'danger',
        });
        break;
      case 'IMUPF_01': {
        send({
          icon: 'profile_filled',
          message: 'Password could not be changed. Please try again later.',
          type: 'danger',
        });
        break;
      }
      case 'IMSIE_01': {
        send({
          icon: 'profile_filled',
          message: 'somethingWentWrong',
          type: 'danger',
        });
        break;
      }
      default:
        send({ message: 'An error occured', type: 'danger' });
    }
  }

  // In production builds, the 3rd argument passed to the following error handler APIs will be a short code instead of the full information string
  // https://vuejs.org/error-reference/#runtime-errors
  nuxtApp.hook('vue:error', (error, instance, info) => {
    if (error instanceof Error) {
      // eslint-disable-next-line no-underscore-dangle
      log.error(error, { component: instance?.$options.__file, errorInfo: info });
    }
    else if (typeof error === 'string') {
      // eslint-disable-next-line no-underscore-dangle
      log.error(error, { component: instance?.$options.__file, errorInfo: info });
    }
  });

  nuxtApp.hook('app:error', (error) => {
    log.error(error);
  });
});
